import type { IConfigManifest, IConfigRoute } from '../interface/config';
import type { IFetcher } from '../interface/util';

function load(fetcher: IFetcher, routing: IConfigRoute): Promise<IConfigManifest> {
    return new Promise(async function (resolve, reject) {
        try {
            const pathFetch = `${routing.basename}/manifest.json`.replace(
                /\/+/g,
                '/',
            ); /* get the base url from config, append /manifest.json & remove double slashes '//' */
            const manifest = await fetcher<IConfigManifest>({
                url: pathFetch,
                method: 'GET',
                expectedResponseType: 'json',
            });

            if (!manifest.payload) {
                reject('Missing payload in response: ' + JSON.stringify(manifest));
            } else {
                resolve(manifest.payload);
            }
        } catch (error) {
            reject(error);
        }
    });
}

export default load;
